
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import s from './ContentModal.module.scss';
const propTypes = {
    children: PropTypes.node.isRequired,
    theme: PropTypes.string
};
const ContentModal = ({ children, theme = 'dark' }) => {
    return (<div data-testid="contentModal" className={cx(s.contentModal, theme)}>
      {children}
    </div>);
};
ContentModal.propTypes = propTypes;
export default ContentModal;

    async function __Next_Translate__getStaticProps__195ca0d16cc__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'src//Profile/components/ContentModal/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__195ca0d16cc__ as getStaticProps }
  